import React from "react";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import DialogTitle from "@mui/material/DialogTitle";
import { FILE_STATE } from "../../../../../redux/constants/metaData";
import { isDocumentReleased } from "../../../../../functions/helperMethod";
import { TruncatedTextWithTooltip } from "../../../../../components/common/TruncatedTextWithTooltip";

export function WorkingDocumentDetailsDialogTitle({
  isDetailsComplete,
  theme,
  workingIfsDocument = {},
  getDocIcon,
}) {
  const isReleased = isDocumentReleased(workingIfsDocument);

  if (isDetailsComplete) {
    return (
      <DialogTitle
        id="alert-dialog-title"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          fontWeight: 600,
          fontSize: "20px",
          fontFamily: theme.fonts.regular,
          padding: "16px",
          paddingTop: "20px",
          color: theme.colors.fontColor,
          minWidth: 0,
          maxWidth: "100%",
          boxSizing: "border-box",
        }}
      >
        <Avatar
          alt={workingIfsDocument.Title}
          src={getDocIcon(
            `${workingIfsDocument.Title}.${workingIfsDocument.FileExtension ?? workingIfsDocument.fileExtension ?? ""}`,
            workingIfsDocument?.FileState === FILE_STATE.checkedOut,
            "avatar",
            isReleased
          )}
          sx={{ width: 28, height: 28, flexShrink: 0 }}
        />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <TruncatedTextWithTooltip
            text={`${workingIfsDocument.Title}.${workingIfsDocument.FileExtension ?? workingIfsDocument.fileExtension ?? ""}`}
            sx={{
              fontWeight: 600,
              lineHeight: 1.2,
              fontFamily: theme.fonts.regular,
              fontSize: "14px",
            }}
          />
        </Box>
      </DialogTitle>
    );
  }
  return null;
}
